import React from "react";
import classNames from "classnames";
import { websiteBuilderGenerateButtonDesignStyles, IWebsiteBuilderButton } from "../../../../../nodes/element/websiteBuilderButton";
import { websiteBuilderFindIconAsset, WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG } from "../../../../../nodes/element/websiteBuilderIcon";
import { useAppSelector } from "hooks/redux";

interface IWebsiteBuilderButtonViewProps {
  node: IWebsiteBuilderButton;
}

export function WebsiteBuilderButtonView(props: IWebsiteBuilderButtonViewProps) {
  const { node } = props;

  const iconAssets = useAppSelector(store => store.websiteBuilderStore.editor.iconAssets);

  const settings = node.element.settings;
  const designStyles = websiteBuilderGenerateButtonDesignStyles(settings);
  
  const iconAsset = websiteBuilderFindIconAsset(iconAssets, settings.icon?.assetIdentity);

  const svg = iconAsset?.svg ?? (settings.icon?.assetIdentity != null ? WEBSITE_BUILDER_MISSING_ICON_ASSET_SVG : null);

  const icon = svg != null ? (
    <div
      className={designStyles.iconClassName}
      dangerouslySetInnerHTML={{
        __html: svg,
      }}
    />
  ) : null;

  return (
    <button
      type="button"
      className={classNames(designStyles.className, "editor-button")}
      style={designStyles.styleProperties}
    >
      <div className={designStyles.contentClassName}>
        {settings.icon?.position === "left" && icon}
        <div className={designStyles.labelClassName}>{settings.label}</div>
        {settings.icon?.position === "right" && icon}
      </div>
    </button>
  );
}
